const e = {
  name: "Speed",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9.4,9.4C12.1,6.7,15.9,5,20,5v2c-3.6,0-6.8,1.5-9.2,3.8L9.4,9.4z"/>
		<path class="st0" d="M0,20C0,9,9,0,20,0c11,0,20,9,20,20s-9,20-20,20C9,40,0,31,0,20z M20,2C10.4,2,2.5,9.5,2,19h8
			c0.5-5.1,4.8-9,10-9c2.4,0,4.6,0.8,6.3,2.3l4-4l1.4,1.4l-4,4c1.2,1.5,2,3.3,2.2,5.3h8C37.5,9.5,29.6,2,20,2z M24.9,13.7
			C23.6,12.6,21.8,12,20,12c-4.1,0-7.4,3.1-7.9,7h4.1c0.4-1.7,2-3,3.9-3c0.7,0,1.4,0.2,2,0.6L24.9,13.7z M23.4,18
			c0.2,0.3,0.3,0.7,0.4,1h4.1c-0.2-1.5-0.8-2.8-1.6-3.9L23.4,18z M20,38c9.6,0,17.5-7.5,18-17H23.9c-0.4,1.7-2,3-3.9,3
			c-1.9,0-3.4-1.3-3.9-3H2C2.5,30.5,10.4,38,20,38z M20,18c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C22,18.9,21.1,18,20,18
			z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Speed
};
